





























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {JudgementGridProps} from '@/types';

interface PageObj {
  page: number;
}

@Component
export default class JudgementListBottomContent extends Vue {
  @Prop({required: false, default: 'content_bottom_wrap', type: String})
  private readonly wrapClass?: string;
  @Prop({
    required: false,
    default: function() {
      return {};
    },
    type: Object
  })
  private readonly customColumnHeader?: {name: string; renderer: any}[];

  @Prop({required: true})
  private gridProps!: JudgementGridProps;

  @Prop({
    required: false,
    default: function() {
      return {};
    },
    type: Object
  })
  private readonly gridOptions?: {[propName: string]: any};

  @Prop({required: true, default: () => []})
  private readonly data!: [];

  @Prop({required: false, default: false, type: Boolean})
  private readonly fireClick?: boolean;

  @Prop({required: false, default: '', type: String})
  private readonly tableTitle?: string;

  get pageOptions() {
    return this.gridProps.pageOptions;
  }

  private afterCall: boolean = false;
  private options = {
    header: {
      height: 33
    },
    rowHeaders: [
      'checkbox',
      {
        type: 'rowNum',
        width: 60
      }
    ],
    columnOptions: {
      minWidth: 50
    },
    minRowHeight: 31,
    rowHeight: 31,
    bodyHeight: 190,
    useClientSort: false,
    pageOptions: {
      perPage: 30,
      page: 1,
      totalCount: 0
    }
  };

  private bodyHeight = 480;

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : this.bodyHeight);
    const pagination = grid.invoke('getPagination') as any;
    if (pagination) {
      const pageState = {
        totalCount: this.pageOptions.totalCount,
        page: this.pageOptions.page,
        perPage: this.pageOptions.perPage - 0
      };
      grid.invoke('resetData', this.data as any, {pageState});
    } else {
      grid.invoke('resetData', this.data as any);
    }
  }

  private created() {
    Object.assign(this.options, {rowHeaders: this.options.rowHeaders || ['rowNum']});
    Object.assign(this.options.header, this.customColumnHeader);

    if (this.gridOptions && Object.keys(this.gridOptions) && this.gridOptions.constructor === Object) {
      if (this.gridOptions.bodyHeight) {
        this.bodyHeight = this.gridOptions.bodyHeight;
      }
      Object.assign(this.options, this.gridOptions);
    }
  }

  private onClick({targetType, rowKey, instance, columnName}: any) {
    if (!this.fireClick) return;
    if (targetType === 'cell') {
      const {radioBtn} = instance.store.column.allColumnMap;
      const row = instance.getRow(rowKey);

      if (columnName === 'applyStatus') {
        this.$emit('onClick', row.productNo);

        return;
      }

      if (radioBtn) {
        const radio = $('.tui-grid-cell-current-row input[type="radio"]');
        radio.prop('checked', true);
        instance.uncheckAll();
        instance.check(rowKey);

        this.$emit('onClick', row);
      }
    }
  }

  private getCheckedItems(propName: string) {
    const grid = this.$refs.tuiGrid as Grid;
    if (propName) {
      const items = grid.invoke('getCheckedRows').map(item => item[propName]);
      return items.join(',');
    } else {
      return grid.invoke('getCheckedRows').map(item => item);
    }
  }

  private mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination')
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('searchBtnClick', ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
  }

}
